module.exports = __webpack_public_path__ + "static/media/gift-card.9b050dc1.svg";